import * as types from './mutation-types'

export const addOrderToCart = ({ commit, dispatch, state },singleOrder) => {
     commit(types.ADD_ORDER_TO_CART, singleOrder)
     commit(types.SAVE_CART)
}

export const editOrderInCart = ({ commit, dispatch, state },data) => {
     commit(types.EDIT_ORDER_IN_CART, data)
     commit(types.SAVE_CART)
}
export const deleteOrderFromCart = ({ commit, dispatch, state },singleOrder) => {
     commit(types.DELETE_ORDER_FROM_CART, singleOrder)
     commit(types.SAVE_CART)
}

export const removeAllOrderFromCart = ({ commit, dispatch, state }) => {
     commit(types.REMOVE_ALL_ORDER_FROM_CART)
     commit(types.SAVE_CART)
}

export const makeOrder = ({ commit, dispatch, state },data) => {

     return new Promise((resolve, reject) => {
          window.axios.post('customer/make/order', data).then((response) => {
              //TODO set cart empty after sending order
               commit(types.REMOVE_ALL_ORDER_FROM_CART)
               commit(types.SAVE_CART)
               resolve(response)
          }).catch(err => {
               reject(err)
          })
     })
}

